import App from "../app";
import Home from "../pages/home";
import Dashboard from "../pages/dashboard";
import NotFound from "../pages/404";
import Terms from "../pages/terms";
import Privacy from "../pages/privacy";
import Contact from "../pages/contact";
import Account from "../pages/account";
import TeachingSettings from "../pages/teaching-settings";
import Signup from "../pages/signup";
import SignupStudent from "../pages/signup-student";
import SignupProfile from "../pages/signup-profile";
import Verify from "../pages/verify";
import Unsubscribe from "../pages/unsubscribe";
import PasswordRecovery from "../pages/password-recovery";
import Plan from "../pages/plan";
import Task from "../pages/task";
import PlayPlan from "../pages/play-plan";
import Browse from "../pages/browse";
import Teacher from "../pages/teacher";
import Moderation from "../pages/moderation";
import Help from "../pages/help";
import Rhythmname from "../articles/rhythmname";
import Listing from "../articles/listing";
import Covid from "../articles/covid";
import Filters from "../articles/filters";
import Experience from "../articles/experience";
import ModerationArticle from "../articles/moderation";
import MetaData from "../articles/meta-data";
import Homework from "../pages/homework";
import Homeworks from "../pages/homeworks";
import HomeworkPlay from "../pages/homework-play";
import HomeworkResult from "../pages/homework-result";
import HomeworkCompleted from "../pages/homework-completed";
import BattleOfTheHuns from "../pages/battle-of-the-huns";
import ChristmasTuning from "../pages/christmas-tuning";
import Translate from "../pages/translate";
import AboutUs from "../pages/about-us";
import Join from "../pages/join";
import ClosedClassroom from "../pages/closed-classroom";
import ModerateExercise from "../pages/moderate-exercise";
import Newsletters from "../pages/newsletters";
import StudentDashboard from "../pages/student-dashboard";
import HomeworkStudentResults from "../pages/homework-student-results";
import routing from "../routing";
import GameAdmin from "../pages/game-admin";
import Login from "../pages/login";

export default [
    {
        ...App,
        routes: [
            {
                ...Home,
                path: "/",
                exact: true,
            },
            {
                ...Login,
                path: `/${routing.login}`,
            },
            {
                ...AboutUs,
                path: `/${routing.aboutUs}`,
            },
            {
                ...Dashboard,
                exact: true,
                path: [`/${routing.dashboard}`, `/${routing.pack}/:id`],
            },
            {
                ...Homeworks,
                exact: true,
                path: [`/${routing.classes}`, `/${routing.classes}/:id`, `/${routing.classes}/:id/${routing.students}`],
            },
            {
                ...Task,
                exact: true,
                path: [
                    `/${routing.plan}/:id/${routing.tasks}/:index`,
                    `/${routing.publicPlan}/:id/${routing.tasks}/:index`,
                ],
            },
            {
                ...Join,
                exact: true,
                path: `/${routing.join}`,
            },
            {
                ...ClosedClassroom,
                path: `/${routing.closedClassroom}`,
            },
            {
                ...Task,
                exact: true,
                path: `/${routing.testModeration}/:id/${routing.tasks}/:index`,
            },
            {
                ...Plan,
                exact: true,
                path: [
                    `/${routing.plan}/:id`,
                    `/${routing.plan}/:id/${routing.scores}`,
                    `/${routing.plan}/:id/${routing.experience}`,
                    `/${routing.plan}/:id/${routing.meta}`,
                    `/${routing.plan}/:id/${routing.meta}/:cat`,
                    `/${routing.publicPlan}/:id`,
                    `/${routing.publicPlan}/:id/${routing.scores}`,
                    `/${routing.publicPlan}/:id/${routing.experience}`,
                    `/${routing.publicPlan}/:id/${routing.meta}`,
                    `/${routing.publicPlan}/:id/${routing.meta}/:cat`,
                ],
            },
            {
                ...ModerateExercise,
                exact: true,
                path: `/${routing.testModeration}`,
            },
            {
                ...Plan,
                exact: true,
                path: [
                    `/${routing.testModeration}/:id`,
                    `/${routing.testModeration}/:id/${routing.experience}`,
                    `/${routing.testModeration}/:id/${routing.meta}`,
                    `/${routing.testModeration}/:id/${routing.meta}/:cat`,
                ],
            },
            {
                ...Terms,
                path: "/" + routing.terms,
            },
            {
                ...Privacy,
                path: "/" + routing.privacy,
            },
            {
                ...Contact,
                path: "/" + routing.contact,
            },
            {
                ...Account,
                path: "/" + routing.account,
            },
            {
                ...TeachingSettings,
                path: "/" + routing.teachingSettings,
            },
            {
                ...Signup,
                path: "/" + routing.signup,
            },
            {
                ...SignupStudent,
                path: "/" + routing.signupStudent,
            },
            {
                ...SignupProfile,
                path: "/" + routing.signupProfile,
            },
            {
                ...Verify,
                path: "/" + routing.verify,
            },
            {
                ...Unsubscribe,
                path: "/" + routing.unsubscribe,
            },
            {
                ...PasswordRecovery,
                path: "/" + routing.passwordRecovery,
            },
            {
                ...PlayPlan,
                path: [
                    `/${routing.play}/:id`,
                    `/${routing.publicPlay}/:id`,
                    `/${routing.share}/:id`,
                    `/${routing.plan}/:id/experience`,
                    `/${routing.publicPlay}/:id/experience`,
                ],
            },
            {
                ...Browse,
                path: `/${routing.browse}`,
            },
            {
                ...Teacher,
                path: `/${routing.teacher}/:teacher`,
            },
            {
                ...Moderation,
                path: `/${routing.moderation}`,
            },
            {
                ...Rhythmname,
                path: `/${routing.help}/${routing.helpRhythmName}`,
            },
            {
                ...Listing,
                path: `/${routing.help}/${routing.helpListingProcess}`,
            },
            {
                ...Covid,
                path: `/${routing.help}/${routing.helpCovid}`,
            },
            {
                ...Filters,
                path: `/${routing.help}/${routing.helpFilters}`,
            },
            {
                ...MetaData,
                path: `/${routing.help}/${routing.helpMeta}`,
            },
            {
                ...Experience,
                path: `/${routing.help}/${routing.helpExperience}`,
            },
            {
                ...ModerationArticle,
                path: `/${routing.help}/${routing.publishingPolicies}`
            },
            {
                ...Help,
                path: `/${routing.help}`,
            },
            {
                ...BattleOfTheHuns,
                path: `/${routing.battleOfTheHuns}`,
            },
            {
                ...Homework,
                path: `/${routing.homework}`,
                exact: true,
            },
            {
                ...HomeworkPlay,
                path: `/${routing.homework}/:id`,
                exact: true,
            },
            {
                ...HomeworkCompleted,
                path: `/${routing.homeworkCompleted}/:id`,
                exact: true,
            },
            {
                ...HomeworkResult,
                path: `/${routing.homeworkResult}/:id`,
            },
            
            {
                ...Newsletters,
                path: `/${routing.newsletter}/:id`
            },
            {
                ...StudentDashboard,
                path:[ `/${routing.dashboardStudent}/:id`, `/${routing.dashboardStudent}`],
            },
            {
                ...HomeworkStudentResults,
                path: `/${routing.homeworkStudentResults}/:id`,
            },
            {
                ...ChristmasTuning,
                path: `/${routing.christmasEdition}`,
            },
            {
                ...Translate,
                path: `/${routing.translate}`,
            },
            {
                ...GameAdmin,
                path: `/game-admin`
            },
            {
                ...NotFound,
            },
        ],
    },
];
